<template>
  <div class="rt-batch-list">
    <el-table
      :data="list"
      stripe
      border
    >
      <slot />
      <el-table-column
        :label="$tx('操作', 'xpc.common.operation')"
        fixed="right"
        sortable
        prop="operation"
        :align="align"
        min-width="130"
      >
        <template slot-scope="scope">
          <div class="operation">
            <rt-button
              v-if="!scope.row.isEdit"
              text
              type="plain"
              @click="edit(scope)"
            >
              {{ $tx('编辑', 'xpc.common.edit') }}
            </rt-button>
            <rt-button
              v-else
              text
              type="plain"
              @click="add(scope)"
            >
              {{ $tx('添加', 'xpc.common.add') }}
            </rt-button>
            <rt-divider direction="vertical" />
            <rt-popconfirm
              :title="
                $tx('确定需要删除这条内容吗？', 'xpc.common.comfirmDelete')
              "
              @confirm="onConfirm(scope.$index)"
            >
              <rt-button
                slot="reference"
                text
                type="plain"
              >
                {{ $tx('删除', 'xpc.common.delete') }}
              </rt-button>
            </rt-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <div
        class="add-btn"
        @click="addBtn"
      >
        <rt-icon
          :color="SCSS_VARIABLES.NEUTRAL_COLOR_REGULAR"
          name="rt-base-plus"
        />
        <span>{{ $tx('添加', 'xpc.common.add') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton';
import RtPopconfirm from '../popconfirm/rtPopconfirm';
import RtDivider from '../divider/rtDivider';
import ElTable from 'vue-xpc/src/element-ui/packages/table';
import ElTableColumn from 'vue-xpc/src/element-ui/packages/table/src/table-column';
export default {
  name: 'RtBatchList',
  components: {
    RtIcon,
    RtButton,
    RtPopconfirm,
    RtDivider,
    ElTable,
    ElTableColumn
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    addNum: {
      type: Number,
      default: 0
    },
    // 操作按钮的对齐方式
    align: {
      type: String,
      default: 'right'
    }
  },
  data () {
    return {
      list: []
    };
  },
  watch: {
    data (newValue) {
      this.$nextTick(() => {
        this.list = JSON.parse(JSON.stringify(newValue));
        this.list.map(item => {
          this.$set(item, 'isEdit', false);
        });
      });
    }
  },
  methods: {
    _updateData () {
      let arr = this.list.map(item => {
        let { isEdit, ...rest } = item;
        return rest;
      });
      this.$emit('update:data', arr);
    },
    edit (scope) {
      scope.row.isEdit = true;
      this.$emit('edit', scope);
    },
    add (scope) {
      scope.row.isEdit = false;
      this._updateData();
      this.$emit('save', scope);
    },
    onConfirm (index) {
      this.del(index);
    },
    del (index) {
      this.list.splice(index, 1);
      this._updateData();
      this.$emit('delete', index);
    },
    addBtn () {
      for (let i = 0; i < this.addNum; i++) {
        this.list.push({ isEdit: true });
      }
    },
    getData () {
      let arr = this.list.filter(item => {
        return !item.isEdit;
      });
      return arr.map(item => {
        let { isEdit, ...data } = item;
        return data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtBatchList.vue?6d2cef03